import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

import Home from "./pages/Home";
import Apply from "./pages/Apply";
import ApplyDomestic from "./pages/ApplyDomestic";
import RecruiterSignup from "./pages/RecruiterSignup";
import RecruiterLogin from "./pages/RecruiterLogin";
import RecruiterDashboard from "./pages/RecruiterDashboard";
import RecruiterSignAgreement from "./pages/RecruiterSignAgreement";
import RecruiterSetPassword from "./pages/RecruiterSetPassword";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apply" element={<Apply />} />
          <Route path="/apply/domestic" element={<ApplyDomestic />} />
          <Route path="/recruiter-signup" element={<RecruiterSignup />} />
          <Route path="/recruiter/login" element={<RecruiterLogin />} />
          <Route
            path="/recruiter/agreement/:token"
            element={<RecruiterSignAgreement />}
          />
          <Route
            path="/recruiter/activate/:token"
            element={<RecruiterSetPassword />}
          />
          <Route
            path="/recruiter/dashboard/*"
            element={
              <ProtectedRoute role="recruiter">
                <RecruiterDashboard />
              </ProtectedRoute>
            }
          />
          <Route path="/admin-login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard/*"
            element={
              <ProtectedRoute role="admin">
                <AdminDashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
        <Toaster position="top-right" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
